import {
  periodColumnDefinition,
  companyCodeColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  bookTypeColumnDefinition,
  currencyCodeColumnDefinition,
  balanceColumnDefinition,
  ytdBalanceColumnDefinition,
  beginningBalanceColumnDefinition,
  entryDateColumnDefinition,
} from '../../../shared/columnDefinitions';
import xlsxExport from '../../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { toastr } from 'react-redux-toastr';
import Config from '../../../config';

export default async ({
  connName,
  clientName,
  periodName,
  trialBalance,
  environmentSuffix,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
}: {
  connName: string,
  clientName: string,
  periodName: string,
  trialBalance: any[],
  environmentSuffix: string,
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
}) => {
  const hasInvalid = trialBalance.some(item =>
    typeof item.periodName !== 'string'
    || typeof item.companyCode !== 'string'
    || typeof item.account !== 'string'
    || typeof item.tradingPartner !== 'string'
    || typeof item.bookType !== 'string'
    || typeof item.currencyCode !== 'string'
    || typeof item.balance !== 'number'
    || typeof item.ytdBalance !== 'number'
    || typeof item.beginningBalance !== 'number'
    || typeof item.createdOn !== 'string'
  );

  if (hasInvalid) {
    toastr.warning(
      '',
      'Some records may be inconsistent. Please contact support if you notice any issues.',
      Config.defaultToastrSettings
    );
  }

  const sheetData = [{
    name: 'Trial Balance Data',
    type: SheetExportTypes.GRID,
    columnDefinitions: [
      periodColumnDefinition,
      companyCodeColumnDefinition,
      accountColumnDefinition,
      tradingPartnerColumnDefinition,
      bookTypeColumnDefinition,
      currencyCodeColumnDefinition,
      balanceColumnDefinition,
      ytdBalanceColumnDefinition,
      beginningBalanceColumnDefinition,
      entryDateColumnDefinition,
    ],
    data: trialBalance,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  const now = new Date();
  const formattedDateTime = now.toISOString().replace(/T/, '_').replace(/:/g, '-').split('.')[0];
  const displayName = `TLS_TrialBalances_${clientName}_${connName}_${periodName}_${environmentSuffix}_${formattedDateTime}`;

  try {
    await xlsxExport({
      sheetData,
      metadata: {
        fileName: displayName,
        disableHeaderRendering: true,
      },
    });
    toastr.success('', 'Trial Balance file was exported successfully', Config.defaultToastrSettings);
  } catch (error) {
    toastr.error('', 'Exporting Trial Balance data to the Excel file failed', Config.defaultToastrSettings);
    throw error;
  }
};
